module.exports = __webpack_public_path__ + "static/media/get-access.7926355b.svg";